// extracted by mini-css-extract-plugin
module.exports = {"ganttsLoader":"Gantts_ganttsLoader_1T_O2"};